import { CSSObject } from "@emotion/react";

export const loadingWrapperCss: CSSObject = {
  height: "70vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const loadingSpinnerWrapperCss: CSSObject = {
  height: "96px",
  width: "96px",
};

export const bodyWrapperCss = (showInstructions: boolean): CSSObject => ({
  display: "grid",
  gridTemplateRows: showInstructions ? "auto 1fr" : "auto",
  height: "100%",
  padding: "24px 16px",
  gap: "24px",
});

export const galleryPreviewWrapperCss = (isStudent: boolean): CSSObject => ({
  display: "grid",
  gridTemplateColumns: isStudent ? "323px 1fr" : "225px 1fr",
  width: "100%",
  height: "100%",
  maxHeight: "800px",
  gap: "16px",
  overflowX: "auto",
  overflowY: "hidden",
});

export const instructionsCss: CSSObject = {
  margin: "0",
};
